// export function trimFormControl(str: string, maxLength?: number): string {
//     return str.length > 50 ? str.substring(0, length) + '...' : str

// }
export function textEllipsis(str: string, maxLength: number, { side = "end", ellipsis = "...", isMandatory = false } = {}) {
    if (str.length > maxLength) {
        switch (side) {
            case "start":
                return ellipsis + str.slice(-(maxLength - ellipsis.length));
            case "end":
            default:
                return str.slice(0, maxLength) + ellipsis;
        }
    }
    return isMandatory ? str + ' *' : str;
}